import { render, staticRenderFns } from "./career-update-list-content.component.vue?vue&type=template&id=89ee1e6c&scoped=true&"
import script from "./career-update-list-content.component.vue?vue&type=script&lang=ts&"
export * from "./career-update-list-content.component.vue?vue&type=script&lang=ts&"
import style0 from "./career-update-list-content.component.vue?vue&type=style&index=0&id=89ee1e6c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ee1e6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
